import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import CoreuiVue from '@coreui/vue'
import CIcon from '@coreui/icons-vue'
import { iconsSet as icons } from '@/assets/icons'
import DocsExample from '@/components/DocsExample'
import 'bootstrap'
import Spinner from '@/components/Spinner.vue'
import VueGoodTablePlugin from 'vue-good-table-next'
import { createPinia } from 'pinia'
import VueSelect from 'vue-select'
import VueProgressBar from '@aacassandra/vue3-progressbar'
import './registerServiceWorker'
import Particles from "@tsparticles/vue3";
import { loadSlim } from "@tsparticles/slim";

// import the styles
import 'vue-good-table-next/dist/vue-good-table-next.css'

const options = {
    color: '#00796B',
    failedColor: '#F44336',
    thickness: '5px',
    transition: {
        speed: '0.4s',
        opacity: '0.6s',
        termination: 300,
    },
    autoRevert: true,
    location: 'top',
    inverse: false,
}

const pinia = createPinia()
const app = createApp(App)
app.use(store)
app.use(router)
app.use(CoreuiVue)
app.use(VueGoodTablePlugin)
app.use(pinia)
app.use(VueProgressBar, options)
app.provide('icons', icons)
app.component('CIcon', CIcon)
app.component('Spinner', Spinner) // spinner
app.component('v-select', VueSelect)
app.use(Particles, {
    init: async engine => {
      // await loadFull(engine); // you can load the full tsParticles library from "tsparticles" if you need it
      await loadSlim(engine); // or you can load the slim version from "@tsparticles/slim" if don't need Shapes or Animations
    },
  })

app.mount('#app')
